"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../lib/helpers");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const A_1 = __importDefault(require("./A"));
const Crumb = (props) => {
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    return props.href
        ? (react_1.default.createElement(A_1.default, Object.assign({}, primitiveProps, { href: props.href }), props.children)) : react_1.default.createElement("span", Object.assign({}, primitiveProps), props.children);
};
exports.default = withJourney_1.default('j-crumb', Crumb, { wrapsHref: false });
